// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const IconRadiobuttonSelected = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15a3 3 0 100-6 3 3 0 000 6zm0 6a9 9 0 100-18 9 9 0 000 18z"
      fill="currentColor"
    />
  );
export default IconRadiobuttonSelected;
